import { AddBox, Delete, Edit } from "@mui/icons-material"
import { Button, Card, CardActions, CardContent, CardMedia, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormLabel, InputLabel, MenuItem, Modal, Select, TextField, Typography } from "@mui/material"
import { toast } from "sonner";
import { useEffect, useRef, useState } from "react";
import axiosInstance from "../../../utils/axiosInstance";

const Challenges = () => {
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [selectedChallenge, setSelectedChallenge] = useState({})
    const [file, setFile] = useState({})

    const [challenges, setChallenges] = useState([{
        challenge_id: '',
        title: '',
        description: '',
        category: '',
        points: '',
        duration: '',
        difficulty: '',
        penalty: '',
        img_url: '',
        createdAt: ''
    }])

    const [challenge, setChallenge] = useState({
        title: '',
        description: '',
        category: '',
        points: '',
        duration: '',
        difficulty: 'easy',
        penalty: '',
        img_url: {}
    })
    const getChallengesRef = useRef();

    const handleOpenEditModal = (challenge) => {
        setIsEditModalOpen(true)
        setSelectedChallenge(challenge)
    }

    const handleOpenDeleteModal = (challenge) => {
        setIsDeleteModalOpen(true)
        setSelectedChallenge(challenge)
    }

    const handleAddChallenge = async () => {
        const formData = new FormData();
        formData.append('title', challenge.title)
        formData.append('description', challenge.description)
        formData.append('category', challenge.category)
        formData.append('points', challenge.points)
        formData.append('duration', challenge.duration)
        formData.append('difficulty', challenge.difficulty)
        formData.append('penalty', challenge.penalty)
        formData.append('img_url', file)

        await axiosInstance.post(`challenges/create`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(() => {
            toast.success(`Success, successfully added ${challenge.title}`)
            setTimeout(() => {
                if(getChallengesRef.current) getChallengesRef.current();
                setIsAddModalOpen(false);
            }, 2000)
        }).catch((error) => {
            console.log(error)
            if(error.response && error.response.data.error) {
                toast.error(`Failure, ${error.response.data.error}`)
            } else {
                toast.error(`Failure, ${error}`)
            }
        })
    }

    const handleEditChallenge = async () => {
        await axiosInstance.put(`challenges/update/${selectedChallenge.challenge_id}`, selectedChallenge).then((response) => {
            toast.success(`Success, successfully edited ${selectedChallenge.title}`)
            setTimeout(() => {
                if(getChallengesRef.current) getChallengesRef.current();
                setIsEditModalOpen(false)
            }, 2000)
        }).catch((error) => {
            if(error.status === 404) {
                toast.error(`Failure, guest not found`)
            } else if(error.status === 400) {
                toast.error(`Failure, ${error.response.error}`)
            } else {
                toast.error(`Failure, ${error}`)
            }
        })
    }

    const handleDeleteChallenge = async () => {        
        await axiosInstance.delete(`challenges/delete/${selectedChallenge.challenge_id}`).then(() => {
            toast.success(`Success, successfully deleted ${selectedChallenge.title}`)
            setTimeout(() => {
                if(getChallengesRef.current) getChallengesRef.current();
                setIsDeleteModalOpen(false)
            }, 2000)
        }).catch((error) => {
            if(error.status === 404) {
                toast.error("Failure! Challenge not found")
            } else if(error.status === 400) {
                toast.error(error.response.data.error || "Cannot delete this Challenge now, try again later.")
            } else {
                toast.error(error)
            }
        })
    }

    useEffect(() => {
        const getChallenges = async () => {
            await axiosInstance.get(`challenges/all`).then((response) => {
                setChallenges(response.data.data);
            }).catch((error) => {
                if(error.response && error.response.data.message === "No challenges found") {
                    setChallenges([]);
                } else if(error.response && error.response.data.message !== "No challenges found") {
                    setChallenges([]);
                } else {
                    setChallenges([]);
                }
            });
        }

        getChallengesRef.current = getChallenges;

        getChallenges()
    }, [])

    return(
        <div>
            <div className="md:flex justify-between md:flex-wrap">
                <Typography variant='h4' className="text-blue-800">Challenges</Typography>
                <div className="mt-4 md:mt-0"><Button className="flex gap-3" variant="outlined" onClick={() => setIsAddModalOpen(true)}><AddBox /> Add challenge</Button></div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-4 px-10 mt-4 gap-4">
                {challenges.length > 0 ? 
                    challenges.map((challenge, index) => (
                        <Card key={index} sx={{ borderRadius: 2, boxShadow: 6 }} className="w-full">
                            <CardMedia sx={{ height: 220 }} image={challenge.img_url} title={challenge.title} />
                            <CardContent>
                                <Typography variant="h5" className="text-green-600">
                                    {challenge.title}
                                </Typography>
                                <Typography variant="body2" color="primary">
                                    {challenge.description}
                                </Typography>
                                <Typography variant="body2">
                                    Category: <b>{challenge.category}<br /></b>
                                    Difficulty: <b>{challenge.difficulty}<br /></b>
                                    Duration: <b>{challenge.duration}<br /></b>
                                    Penalty: <b>{challenge.penalty}<br /></b>
                                    Points: <b>{challenge.points} points<br /></b>
                                    Created on: <b>{challenge.createdAt.slice(0,10)}</b>
                                </Typography>
                                <CardActions>
                                    <Button variant="contained" size="small" color="primary" onClick={() => handleOpenEditModal(challenge)} style={{ marginRight: 10 }} className="text-sm">
                                        <Edit /> Edit
                                    </Button>
                                    <Button variant="contained" size="small" color="error" onClick={() => handleOpenDeleteModal(challenge)}>
                                        <Delete fontSize="small" /> Delete
                                    </Button>
                                </CardActions>
                            </CardContent>
                        </Card>
                    ))
                :
                    <div className="w-full text-red-500 font-bold text-center text-xl">Challenges not created yet</div>
                }
            </div>

            {/* Delete Confirmation Modal */}
            <Dialog open={isDeleteModalOpen} onClose={() => setIsDeleteModalOpen(false)}>
                <DialogTitle className="text-blue-950">Delete Confirmation</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete {selectedChallenge.title} challenge?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsDeleteModalOpen(false)} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleDeleteChallenge} color="error" variant="outlined">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Edit Instructor Modal */}
            <Modal open={isEditModalOpen} onClose={() => setIsEditModalOpen(false)} className="flex justify-center items-center" aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div className='bg-white w-[90%] lg:w-[40%] shadow p-8 rounded-sm'>
                    <h2 className="text-blue-950 mb-8">Edit Challenge</h2>
                    <div>
                        <TextField variant="outlined" fullWidth type="text" value={selectedChallenge.title} onChange={(e) => setSelectedChallenge((prev) => ({...prev, title: e.target.value}))} label="Entet title" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth type="text" multiline rows={4} value={selectedChallenge.description} onChange={(e) => setSelectedChallenge((prev) => ({...prev, description: e.target.value}))} label="description" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth type="text" value={selectedChallenge.category} onChange={(e) => setSelectedChallenge((prev) => ({...prev, category: e.target.value}))} label="Category" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth type="text" value={selectedChallenge.points} onChange={(e) => setSelectedChallenge((prev) => ({...prev, points: e.target.value}))} label="Points" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth type="text" value={selectedChallenge.duration} onChange={(e) => setSelectedChallenge((prev) => ({...prev, duration: e.target.value}))} label="Duration" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth type="text" value={selectedChallenge.difficulty} onChange={(e) => setSelectedChallenge((prev) => ({...prev, difficulty: e.target.value}))} label="Difficulty" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth type="text" value={selectedChallenge.penalty} onChange={(e) => setSelectedChallenge((prev) => ({...prev, penalty: e.target.value}))} label="Penalty" style={{ marginBottom: 10 }} />
                    </div>
                    <div className="flex items-center justify-center gap-8 w-[90%] mx-auto mt-4">
                        <Button onClick={() => setIsEditModalOpen(false)} color="secondary" fullWidth variant="outlined">
                            Cancel
                        </Button>
                        <Button color="primary" fullWidth variant="outlined" onClick={handleEditChallenge}>
                            Save
                        </Button>
                    </div>
                </div>
            </Modal>

            {/* Add challenge Modal */}
            <Modal open={isAddModalOpen} onClose={() => setIsAddModalOpen(false)} className="flex justify-center items-center" aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div className='bg-white w-[90%] lg:w-[40%] shadow p-8 rounded-sm'>
                    <h2 className="text-blue-950 mb-8">Add challenge</h2>
                    <div>
                        <TextField variant="outlined" fullWidth type="text" value={challenge.title} onChange={(e) => setChallenge((prev) => ({...prev, title: e.target.value}))} label="Entet title" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth type="text" multiline rows={4} value={challenge.description} onChange={(e) => setChallenge((prev) => ({...prev, description: e.target.value}))} label="description" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth type="text" value={challenge.category} onChange={(e) => setChallenge((prev) => ({...prev, category: e.target.value}))} label="Category" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth type="text" value={challenge.points} onChange={(e) => setChallenge((prev) => ({...prev, points: e.target.value}))} label="Points" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth type="text" value={challenge.duration} onChange={(e) => setChallenge((prev) => ({...prev, duration: e.target.value}))} label="Duration" style={{ marginBottom: 10 }} />
                        <FormControl fullWidth style={{ marginBottom: 10 }}>
                            <InputLabel>Difficulty</InputLabel>
                            <Select label="Select difficulty" value={challenge.difficulty} onChange={(e) => setChallenge((prev) => ({...prev, difficulty: e.target.value}))} >
                                <MenuItem value="easy">
                                    Easy
                                </MenuItem>
                                <MenuItem value="medium">
                                    Medium
                                </MenuItem>
                                <MenuItem value="hard">
                                    Hard
                                </MenuItem>
                            </Select>
                        </FormControl>
                        <TextField variant="outlined" fullWidth type="text" value={challenge.penalty} onChange={(e) => setChallenge((prev) => ({...prev, penalty: e.target.value}))} label="Penalty" style={{ marginBottom: 10 }} />
                        <FormLabel>Upload challenge image</FormLabel>
                        <TextField variant="outlined" fullWidth type="file" onChange={(e) => setFile(e.target.files[0])} style={{ marginBottom: 10 }} />
                    </div>
                    <div className="flex items-center justify-center gap-8 w-[90%] mx-auto mt-4">
                        <Button onClick={() => setIsAddModalOpen(false)} color="secondary" variant="outlined" fullWidth>
                            Cancel
                        </Button>
                        <Button color="primary" variant="outlined" fullWidth onClick={handleAddChallenge}>
                            Save
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default Challenges